<template>
  <el-dialog
    :title="model.id ? '编辑零件' : '添加零件'"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="名称" prop="name">
        <el-input v-model="model.name"></el-input>
      </el-form-item>
      <el-form-item label="编码" prop="code">
        <el-input v-model="model.code"></el-input>
      </el-form-item>
      <el-form-item label="规格" prop="specification">
        <el-input v-model="model.specification"></el-input>
      </el-form-item>
      <el-form-item label="型号" prop="model_number">
        <el-input v-model="model.model_number"></el-input>
      </el-form-item>
      <el-form-item label="单位" prop="unit">
        <el-input v-model="model.unit"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="model.remark"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { itemNew, itemUpdate } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        code: [{ required: true, message: '请填写编码' }],
        name: [{ required: true, message: '请填写名称' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await itemUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await itemNew(data)
            if (res.status == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>